<template>
  <v-container>
    <div>
      <v-btn :ripple="false" text @click="openPoolsPage" color="var(--v-resWhite-base)" class="ml-2 pl-0">
        <v-btn small color="var(--v-resBlue-darken1)" icon><v-icon size="18" dark>arrow_back</v-icon></v-btn>
        <span class="text-none ml-0 back-button-text resBlue-darken1--text">{{ poolInfo.propertyName }}</span>
      </v-btn>
    </div>
    <v-app-bar flat>
      <drop-down
        :items="'Recovery Cycles'"
        :label="'Select Cycle'"
        width="240px"
        :genericLabel="true"
        :multiple='false'
        :getParams="{ propertyId: poolInfo.property }"
        @itemSelected="selectCycle">
      </drop-down>
    </v-app-bar>
    <div v-if="selectedCycle" class="ml-4 mt-6 mb-2">
      <span class="title">{{ poolInfo.poolName }} <span class="resGray-darken4--text" v-if="selectedPoolInfo">{{ selectedPoolInfo.poolFrequencyName ? `(${selectedPoolInfo.poolFrequencyName})` : ''}}</span>
        <v-icon v-if="selectedPoolInfo && selectedPoolInfo.estimateIsLocked" :color="'var(--v-resGreen-base)'" medium>lock</v-icon>
      </span>
    </div>
    <estimates-cycle-info-card
      v-if="selectedCycle && selectedPoolInfo"
      :cycle="selectedPoolInfo">
    </estimates-cycle-info-card>
    <div v-if="selectedCycle" class="ml-4 mt-6 mb-2">
      <span class="title">Cycle Estimates</span>
    </div>
    <estimates-table
      v-if="selectedCycle && selectedPoolInfo"
      class="mb-4"
      :cycle="selectedPoolInfo"
      :selectedTab="selectedTab"
      @launchDetails="launchDetails"
      @showChargesDialog="showEstimateCharges"
      @showReportDialog="showEstimateReports"
      @refreshCycle="refreshCycle">
    </estimates-table>
    <!-- Dialogs -->
    <expense-recovery-account-details-dialog
      v-if="showExpenseRecoveryAccountDetailsDialog && selectedAccountInfo"
      :showDialog="showExpenseRecoveryAccountDetailsDialog"
      :accountInfo="selectedAccountInfo"
      @cancelDialog="hideExpenseRecoveryAccountDetailsDialog"
      @save="hideExpenseRecoveryAccountDetailsDialog">
    </expense-recovery-account-details-dialog>
    <estimate-charges-dialog
      v-if="showEstimateChargesDialog"
      :showDialog="showEstimateChargesDialog"
      @cancelDialog="hideEstimateChargesDialog"
      @confirmEstimateCharges="confirmEstimateCharges">
    </estimate-charges-dialog>
    <estimate-reports-dialog
      :showDialog="showEstimateReportsDialog"
      :cycleInfo="selectedPoolInfo"
      @cancelDialog="hideEstimatesReportDialog">
    </estimate-reports-dialog>
  </v-container>
</template>

<script>
import DropDown from '../../BaseComponents/DropDown'
import EstimatesCycleInfoCard from './EstimatesCycleInfoCard'
import EstimatesTable from './EstimatesTable'
import ExpenseRecoveryAccountDetailsDialog from './Dialogs/ExpenseRecoveryAccountDetails'
import EstimateChargesDialog from './Dialogs/EstimateCharges'
import EstimateReportsDialog from './Dialogs/EstimateReports'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['poolInfo'],
  components: {
    DropDown,
    EstimatesCycleInfoCard,
    EstimatesTable,
    ExpenseRecoveryAccountDetailsDialog,
    EstimateChargesDialog,
    EstimateReportsDialog
  },
  data () {
    return {
      selectedTab: 0,
      selectedCycle: null,
      showExpenseRecoveryAccountDetailsDialog: false,
      showEstimateChargesDialog: false,
      showEstimateReportsDialog: false,
      selectedAccountInfo: null
    }
  },
  methods: {
    ...mapActions(['fetchData', 'changeData', 'initializeStoreItem']),
    selectCycle (val) {
      this.selectedCycle = val.value
      this.getCycleInfo()
    },
    getCycleInfo () {
      this.fetchData({
        newPage: 'Recovery Cycles',
        params: {
          property: this.poolInfo.property,
          chargeCode: this.poolInfo.chargeCode,
          cycleNumber: this.selectedCycle
        }
      }).catch(error => { console.log(error.response) })
    },
    openPoolsPage () {
      this.$emit('openPoolsPage')
    },
    showEstimateCharges () {
      this.showEstimateChargesDialog = true
    },
    hideEstimateChargesDialog () {
      this.showEstimateChargesDialog = false
    },
    showEstimateReports () {
      this.showEstimateReportsDialog = true
    },
    hideEstimatesReportDialog () {
      this.showEstimateReportsDialog = false
    },
    confirmEstimateCharges (e) {
      this.changeData({
        currentPage: 'Estimates Lease Expenses',
        newData: {
          property: this.poolInfo.property,
          chargeCode: this.poolInfo.poolName,
          cycleNumber: this.selectedCycle,
          chargeDate: e
        }
      }).then(() => {
        this.showEstimateChargesDialog = false
        this.refreshCycle()
      }).catch(error => { console.log(error.response) })
    },
    launchDetails (e) {
      this.selectedAccountInfo = {
        property: this.poolInfo.property,
        chargeCode: this.poolInfo.chargeCode,
        cycleNumber: this.selectedCycle,
        account: e.account,
        accountList: e.accountList,
        accountName: e.accountName,
        actuals: e.actuals,
        budget: e.budgets,
        difference: e.budgets - e.actuals
      }
      this.showExpenseRecoveryAccountDetailsDialog = true
    },
    hideExpenseRecoveryAccountDetailsDialog () {
      this.showExpenseRecoveryAccountDetailsDialog = false
    },
    refreshCycle () {
      this.initializeStoreItem('Recovery Cycles')
      if (this.selectedCycle) {
        this.getCycleInfo()
      }
    }
  },
  computed: {
    ...mapGetters(['currentData']),
    selectedPoolInfo () {
      return this.currentData('Recovery Cycles').length !== 0 ? this.currentData('Recovery Cycles') : null
    }
  }
}
</script>

<style lang="scss" scoped>
  .back-button {
    &__icon {
      width:20px;
      height:20px;
    }
  }
</style>
